export class RowsDeleteByIdsRequest
{
    constructor(
            public readonly rowIds:number[]
        )
    {}
}
